import SettingsIndexController from 'cio/pods/base/setup/settings/index/controller';

export default SettingsIndexController;
